module.exports = __webpack_public_path__ + "media/images/pub/loginbkg-ea7ba7daae1d271dde006fc7cfe2ebd0.png";